module.exports = __webpack_public_path__ + "static/img/bill.9a55bd2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/bill.png
// module id = LieA
// module chunks = 170